export default "__VITE_ASSET__36799345__"